
import history from '../history'
import moment from 'moment'
import store from '../redux/store'
import {
  userImpersonateReset
} from '../redux/actions'
export const AUTH_TOKEN_REFRESH_BEFORE = 300
moment.suppressDeprecationWarnings = true;

class Auth {

  constructor() {
    this.isAuthenticated = this.isAuthenticated.bind(this)
  }

  handleAuthentication(authResult) {
    sessionStorage.setItem('id_token', authResult.access_token)
    sessionStorage.setItem('id_refresh_token', authResult.refresh_token)
    sessionStorage.setItem('expires', authResult.expires)
  }

  isAuthenticated() {
    try {
      let expiresAt = JSON.parse(sessionStorage.getItem('expires'))
      let authenticated = moment().unix() < expiresAt
      return authenticated
    }catch(e){
      return false
    }

  }

  login() {
    return null
  }

  logout() {
    sessionStorage.removeItem('id_token')
    sessionStorage.removeItem('id_refresh_token')
    sessionStorage.removeItem('expires')
    sessionStorage.removeItem('idc_state')
    sessionStorage.removeItem('JOB_SEARCH_FILTER')
    sessionStorage.removeItem('JOB_SEARCH_PARAMS')
    //history.replace('/login')
    this.clearReduxStore();
    window.location.href = '/login'
  }

  clearReduxStore() {
    // store.dispatch(userImpersonateReset())
    store.dispatch({type : 'USER_LOGOUT'})
  }
}

export default Auth
